import { render, staticRenderFns } from "./journeyEditDragAndDrop.vue?vue&type=template&id=7fed32a5&scoped=true&"
import script from "./journeyEditDragAndDrop.vue?vue&type=script&lang=js&"
export * from "./journeyEditDragAndDrop.vue?vue&type=script&lang=js&"
import style0 from "./journeyEditDragAndDrop.vue?vue&type=style&index=0&id=7fed32a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fed32a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAvatar,VBtn,VCol,VContainer,VRow,VTextarea})
